import { useState } from "react";
import { Copy, Check, Layers } from "lucide-react";

const Section = ({ title, cards, color }) => {
  if (!cards?.length) return null;
  const total = cards.reduce((a, c) => a + (c.qty || 1), 0);
  return (
    <div className="mb-4" data-testid={`decklist-${title.toLowerCase().replace(" ", "-")}`}>
      <div className={`flex items-center justify-between px-3 py-1.5 rounded-t-lg text-xs font-black uppercase tracking-wider ${color}`}>
        <span>{title}</span><span>{total} cartas</span>
      </div>
      <ul className="bg-black/40 border border-purple-800/40 rounded-b-lg divide-y divide-purple-900/40">
        {cards.map((c, i) => (
          <li key={i} className="flex items-center gap-3 px-3 py-1.5 text-sm hover:bg-purple-900/30 transition-colors">
            <span className="w-7 h-6 rounded bg-purple-800/60 text-yellow-300 font-bold text-xs flex items-center justify-center">{c.qty}x</span>
            <span className="text-gray-200">{c.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const DecklistBlock = ({ decklist, decklistText }) => {
  const [copied, setCopied] = useState(false);
  if (!decklist || (!decklist.main?.length && !decklist.extra?.length && !decklist.side?.length)) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(decklistText || "");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = decklistText || "";
      document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="glass-card rounded-2xl p-5 border border-purple-500/30 my-8" data-testid="decklist-block">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="flex items-center gap-2 text-lg font-black text-yellow-400"><Layers size={20} /> Decklist</h3>
        <button onClick={copy} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all ${copied ? "bg-emerald-500 text-black" : "bg-gradient-to-r from-pink-500 to-purple-600 text-white hover:shadow-lg hover:shadow-pink-500/30"}`} data-testid="copy-decklist-btn">
          {copied ? <><Check size={16} /> ¡Copiada!</> : <><Copy size={16} /> Copiar lista al portapapeles</>}
        </button>
      </div>
      <Section title="Main Deck" cards={decklist.main} color="bg-purple-700/70 text-white" />
      <Section title="Extra Deck" cards={decklist.extra} color="bg-orange-600/70 text-white" />
      <Section title="Side Deck" cards={decklist.side} color="bg-cyan-600/70 text-white" />
    </div>
  );
};
